import { validateEnumTranslations } from '../../safety_checks';
import { StripeConnectPayoutInterval, StripeConnectPayoutStatus } from '../stripe_connect';

export const TRANSLATE_KEY_STRIPE_CONNECT_PAYOUT_STATUS = 'STRIPE_CONNECT_PAYOUT_STATUS_';

export const StripeConnectPayoutStatusTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_STRIPE_CONNECT_PAYOUT_STATUS}${StripeConnectPayoutStatus.PAID}`]: 'Effectué',
    [`${TRANSLATE_KEY_STRIPE_CONNECT_PAYOUT_STATUS}${StripeConnectPayoutStatus.PENDING}`]: 'En attente',
    [`${TRANSLATE_KEY_STRIPE_CONNECT_PAYOUT_STATUS}${StripeConnectPayoutStatus.IN_TRANSIT}`]: 'En cours de virement',
    [`${TRANSLATE_KEY_STRIPE_CONNECT_PAYOUT_STATUS}${StripeConnectPayoutStatus.CANCELED}`]: 'Annulé',
    [`${TRANSLATE_KEY_STRIPE_CONNECT_PAYOUT_STATUS}${StripeConnectPayoutStatus.FAILED}`]: 'Échoué',
  },
};

validateEnumTranslations(
  StripeConnectPayoutStatus,
  StripeConnectPayoutStatusTranslation,
  TRANSLATE_KEY_STRIPE_CONNECT_PAYOUT_STATUS,
  true,
);

export const TRANSLATE_KEY_STRIPE_CONNECT_PAYOUT_INTERVAL = 'STRIPE_CONNECT_PAYOUT_INTERVAL_';

export const StripeConnectPayoutIntervalTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_STRIPE_CONNECT_PAYOUT_INTERVAL}${StripeConnectPayoutInterval.DAILY}`]: 'Quotidienne',
    [`${TRANSLATE_KEY_STRIPE_CONNECT_PAYOUT_INTERVAL}${StripeConnectPayoutInterval.WEEKLY}`]: 'Hebdomadaire',
    [`${TRANSLATE_KEY_STRIPE_CONNECT_PAYOUT_INTERVAL}${StripeConnectPayoutInterval.MONTHLY}`]: 'Mensuelle',
    [`${TRANSLATE_KEY_STRIPE_CONNECT_PAYOUT_INTERVAL}${StripeConnectPayoutInterval.MANUAL}`]: 'Manuelle',
  },
};

validateEnumTranslations(
  StripeConnectPayoutInterval,
  StripeConnectPayoutIntervalTranslation,
  TRANSLATE_KEY_STRIPE_CONNECT_PAYOUT_INTERVAL,
  true,
);
